import React, { ReactElement } from 'react';
import { ReportDashboard } from '../../libs/report/ReportDashboard';

export function ReportIndexPage(): ReactElement {
  return <ReportDashboard />;
}
